import { Component, OnInit } from '@angular/core';

import { AppService } from '../../services/app.service';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { VotacionService } from 'src/app/services/votacion/votacion.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

import Swal from 'sweetalert2';

interface Pregunta {
  id: number;
  nombre: string;
  activo: boolean;
  opcion: { id: number; nombre: string; idPregunta: number; activo: boolean }[];
}
@Component({
  selector: 'app-votacion',
  templateUrl: '../../pages/votacion/votacion.component.html',
  styleUrls: ['../../pages/votacion/votacion.component.css']
})
export class VotacionComponent implements OnInit 
{
    options = { autoClose: true, keepAfterRouteChange: false };
    mensaje: boolean = false;
    mensajeError: string;
    nombreUsuario: string = localStorage.getItem("nombreUsuario");
    idUsuario = localStorage.getItem("idUsuario")
    seleccionTrabajo: string = '';
    seleccionRegion: string = '';
    seleccionCandidato: string = '';
    preguntas: Pregunta[] = [];
    seleccionRespuestas: { [key: number]: number } = {};

    constructor(private appService: AppService,private dialog: MatDialog,
    private router:Router, private route: ActivatedRoute, private votacionService:VotacionService) { }

    ngOnInit(): void  
    { 
      var vm = this;
      const menu = document.querySelector('.menu') as HTMLElement;
      if (menu) {
        menu.style.display = 'none';
      }
      if(!localStorage.getItem("rol"))
        {
          vm.openAlertDialog("Debe estar logueado para poder votar", "btn-danger")               
          this.appService.setUserLoggedIn(null);  
          localStorage.removeItem('rol');  
          localStorage.removeItem('jubilado');  
          this.router.navigate(['/login']); 
          return;
        }


      this.votacionService.obtieneVotacion(1)
      .then((response: Pregunta[]) => {
        this.preguntas = response;
      })
      .catch((error) => {
        console.error(error);
        this.mensajeError = 'Error al obtener las preguntas.';
      });

      this.votacionService.existeVotacionUsuario(this.idUsuario)
      .then((response) => {
       if(response==true){
        vm.openAlertDialog("Estimado afiliado, usted ya tiene una votación previa", "btn-danger")               
        setTimeout(function () {
          vm.router.navigate(['/index']);
        }, 3000);
       }       
        console.log("existeVotoPrevio:",response)
      })
      .catch((error) => {
        console.error(error);
        this.mensajeError = 'Error al obtener votación previa.';
      });
    
    }

    enviarVotacion() {
      var vm = this;
    

      if (!vm.idUsuario) {
        this.openAlertDialog('Debe ingresar con un afiliado válido.', 'btn-danger')
        return false;
      }

      if (!vm.seleccionRespuestas[1]) {
        this.openAlertDialog('Debe ingresar una respuesta para saber en qué lugar de trabajo se desempeña.', 'btn-danger')
        return false;
      }

      if (!vm.seleccionRespuestas[2]) {
        this.openAlertDialog('Debe ingresar una respuesta en Dirección Regional.', 'btn-danger')
        return false;
      }

      if (!vm.seleccionRespuestas[3]) {
        this.openAlertDialog('Debe seleccionar un candidato.', 'btn-danger')
        return false;
      }
  
      // Aquí podrías llamar al servicio para enviar la votación
      const lugarTrabajo  =vm.seleccionRespuestas[1]
      const direccionRegional  =vm.seleccionRespuestas[2]
      const candidato  =vm.seleccionRespuestas[3]
      this.votacionService.enviarVotacion(vm.idUsuario,lugarTrabajo,direccionRegional,candidato).then
      (
        () => 
        {         
            vm.openAlertDialog("su votación ha sido realizada exitosamente", "btn-success")               
            setTimeout(function () {
              const menu = document.querySelector('.menu') as HTMLElement;
              if (menu) {
                menu.style.display = 'block';
              }
              if(localStorage.getItem("jubilado")=='true'){
                vm.router.navigate(['/index-jub']);                
              }else{
                vm.router.navigate(['/index']);
              }
              
            }, 3000);
        }
    )
    .catch
    (
        error => 
        {        
            const menu = document.querySelector('.menu') as HTMLElement;
            if (menu) {
              menu.style.display = 'block';
            } 
            vm.openAlertDialog(error.error.message, "btn-danger")
        }
    )
    }



      aprobarDesafiliacionAfiliado(rut: any) {
        let vm = this;
      
                   
      }

      openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent, {
          data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
      }
    
      

}
